/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';
import { useTokenContext } from "@exo/frontend-common-app-identity-and-access";


const UNSUBSCRIBE = gql`
mutation Unsubscribe($email: String!) {
  unsubscribe(email: $email) {
    success
  }
}
`;

const UNSUBSCRIBESUBSCRIBE = gql`
mutation unsubscribeSubscription($email: String!) {
  unsubscribeSubscription(email: $email) {
    success
  }
}
`;

export const useUnsubscribe = () => {
  const tokenContext = useTokenContext();
  const [unsubscribeMutation] = useMutation(UNSUBSCRIBE,{context:{clientName:"notification"}});

  return {
    unsubscribeApi: async (email) => {
      await tokenContext.ensureValidToken();
      const response = await unsubscribeMutation({ variables: email });
      return response;
    }
  }
}

export const useUnsubscribeSubscribe = () => {
  const tokenContext = useTokenContext();
  const [unsubscribeSubMutation] = useMutation(UNSUBSCRIBESUBSCRIBE);

  return {
    unsubscribeSubApi: async (email) => {
      await tokenContext.ensureValidToken();
      const response = await unsubscribeSubMutation({ variables: email });
      return response;
    }
  }
}

